import REWARD_IMAGE_1 from '../../../assets/images/club/rewards/club-reward-3.webp';
import rewardTypes from '../../../consts/loyalty/rewardTypes';
import {strCode} from '../../../consts/strCode';

const CLUB_PAGE_REWARDS_CONTENT = {
    [rewardTypes.FREE_COFFEE]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_COFFEE_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.IQOS_RING]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_IQOS_RING_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.IQOS_RINGS]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_IQOS_RINGS_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.TEREA_PACK]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_TEREA_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.LEVIA_PACK]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_LEVIA_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.IQOS_DRINK]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_DRINK_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
    [rewardTypes.TEREA_LEVIA_PACK]: {
        titleStrCode: strCode.CLUB_PAGE_REWARDS_TEREA_LEVIA_REWARD_TITLE,
        imageSrc: REWARD_IMAGE_1,
    },
};

export default CLUB_PAGE_REWARDS_CONTENT;
